import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'

import LoaderSingleComponent from '../@react-fefmwk/loader-app/modules/LoaderSingleComponent'
import PieChartIcon from '@material-ui/icons/PieChart'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import TimelineIcon from '@material-ui/icons/Timeline'

import { users_dashboard } from '../services/BE'

import FilePreview from './pieces/FilePreview'

import { Box, Card, CardContent, Divider, Grid, Chip, Typography, Paper } from '@material-ui/core'

const styles = theme => ({
    gp: {
        backgroundColor: theme.palette.warning[100],
        color: theme.palette.warning[800],
        fontWeight: "bold"
    },
    adv: {
        backgroundColor: theme.palette.error[100],
        color: theme.palette.error[600],
        fontWeight: "bold"
    },
    ret: {
        backgroundColor: theme.palette.info[100],
        color: theme.palette.info[800],
        fontWeight: "bold"
    },
    accountBox: {
        border: "1px solid",
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.borderRadius
    },
    enabledAccountBox: {
        //silence is golden
    },
    disabledAccountBox: {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[400],
    },
    enabledChip: {
        backgroundColor: theme.palette.success[100],
        color: theme.palette.success.main,
        fontWeight: "normal"
    },
    disabledChip: {
        backgroundColor: theme.palette.grey[500],
        color: theme.palette.grey[300],
        fontWeight: "normal"
    }
})
const dbAreas = area => {
    const db = {
        gp: {
            description: "Rendicontazione ufficiale giornaliera relativa ai mandati di gestione patrimoniali",
            icon: PieChartIcon
        },
        adv: {
            description: "Rendicontazione ufficiale giornaliera relativa ai mandati di consulenza finanziaria",
            icon: AccountCircleIcon
        },
        ret: {
            description: "Rendicontazione ufficiale giornaliera relativa alle posizioni dei sottoscrittori diretti dei fondi Anthilia",
            icon: TimelineIcon
        },
    }
    return db.hasOwnProperty(area)
        ? db[area]
        : {}
}

const MyDashboard = (props) => {
    const [areas, setAreas] = useState([])

    const id_user = props.id_user
    useEffect(() => {
        const getAreas = async () => {
            const areas = id_user
                ? await users_dashboard(id_user)
                : []
            setAreas(areas)
        }
        getAreas()
    }, [])

    if (!areas.length)
        return <LoaderSingleComponent width="100%" />

    const classes = props.classes

    return <>
        <Box>
            <Grid container spacing={4}>
                {areas.map((area, i) => {
                    const area_name = area.area_name
                    const area_label = area.area_label
                    const area_idcodes = area.idcodes
                    const dbArea = dbAreas(area_name)
                    const area_description = dbArea.hasOwnProperty('description')
                        ? dbArea.description
                        : ""
                    const AreaIcon = dbArea.hasOwnProperty('icon')
                        ? dbArea.icon
                        : null
                    return <Grid key={`area-${i}`} item xs={12} md={6} lg={4}>
                        <Card>
                            <CardContent>
                                <Box mb={2}>
                                    <Chip label={area_label} size="small"
                                        className={classes[area_name]}
                                        icon={<AreaIcon fontSize="small" className={classes[area_name]} />}
                                    />
                                    {area_description
                                        ? <Typography variant="body2" component={Box} pt={2}>
                                            {area_description}
                                        </Typography>
                                        : null}
                                </Box>
                                <Box mt={3}>
                                    {area_idcodes.length
                                        ? (area_idcodes.map((_idcode,i) => {
                                            const idcode = _idcode.idcode
                                            const idcode_files = _idcode.files
                                            const idcode_label = _idcode.idcode_label
                                                ? _idcode.idcode_label
                                                : ("Conto "+idcode)
                                            const enabled = _idcode.enabled
                                            const enabled_label = enabled
                                                ? "attivo"
                                                : "non attivo"
                                            const enabledChip_class = enabled
                                                ? classes.enabledChip
                                                : classes.disabledChip
                                            const enabledAccountBox_class = enabled
                                                ? classes.enabledAccountBox
                                                : classes.disabledAccountBox
                                            const key = area+"-"+idcode
                                            return <Box key={key} mt={3}>
                                                <Box p={2} className={clsx(classes.accountBox,enabledAccountBox_class)}>
                                                    <Grid container alignItems="center">
                                                        <Grid item xs>
                                                            <Typography component="div" variant="h6">
                                                                {idcode_label}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs="auto">
                                                            <Chip label={enabled_label} size="small" className={enabledChip_class} />
                                                        </Grid>
                                                    </Grid>
                                                    <Box mt={3}>
                                                        {idcode_files.length
                                                            ? (idcode_files.map((file,f) => {
                                                                return <FilePreview {...file} key={key+"-"+f} disabled={!enabled} />
                                                            }))
                                                            : <FilePreview basename="File non disponibile al momento"
                                                                mime_type="default"
                                                                disabled={true}
                                                            />}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        }))
                                        : "no files found"}
                                    {}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                })}
            </Grid>
        </Box>
    </>
}

export default withStyles(styles)(MyDashboard)